import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import DesignerButton from './DesignerButton';
import DesignerTextField from './DesignerTextField';

import QRCode from 'react-qr-code';

import { checkForCode, getRoomId, androidBackButton } from './Utils';

import penClick from './Sounds/pen-click.wav';

class TeamAndWords extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;
    this.penClick = new Audio(penClick);

    this.state = {
      roomID: '',

      categories: [],
      wordsPerPerson: 0,
      numberOfTeams: 3,
      roomOwner: '',

      coloredTeams: [],
      selectedTeam: '',
      wordsArray: [],

      qrCodeOpen: false,
    };
  }

  componentDidMount() {
    androidBackButton(this.handleGoBackRoom);
    checkForCode('GET', `/api/rooms/${getRoomId()}`, this.props, null).then(
      (data) => {
        let newColoredTeams;

        if (data.RandomTeams) {
          console.log("here");
          newColoredTeams = [
            {
              teamName: 'Случаен',
              displayName: 'Случаен'
            },
          ];
        } else {
          newColoredTeams = data.teams;
        }

        this.setState({
          roomID: data.roomID,
          numberOfTeams: data.teams.length,
          coloredTeams: newColoredTeams,
          selectedTeam: newColoredTeams[0].teamName,
          roomOwner: data.owner,
          gameName: data.gameName,
          categories: data.categories,
          wordsPerPerson: data.wordsPerPerson,
          wordsArray: Array(data.wordsPerPerson).fill(''),
        });
      }
    );
  }

  handleWordsArrayInput = (event, index) => {
    // eslint-disable-next-line
    this.state.wordsArray[index] = event.target.value;
    this.forceUpdate();
  };

  handleGoBackRoom = async () => {
    await checkForCode(
      'PUT',
      `/api/rooms/${this.props.cookies.get('code')}/deleteRoom`,
      this.props,
      null
    ).then(async (data) => {
      console.log('data deleted');
      //if deletedCount === 0 this means that the user was not
      //the owner of the game that he was in
      if (data.deletedCount === 0) {
        //remove player
        await checkForCode(
          'PUT',
          `/api/rooms/${getRoomId()}/leaveRoom`,
          this.props,
          null
        ).then((data) => {
          this.penClick.play();
          this.props.navigate(`/JoinRoom`);
        });
      } else {
        this.penClick.play();
        this.props.navigate(`/CreateGame`);
      }
    });
  };

  areAllInputsFilled = () => {
    let MissingInput = false;
    const wordsArray = this.state.wordsArray;
    for (let index = 0; index < wordsArray.length; index++) {
      if (wordsArray[index] === '') {
        MissingInput = true;
      }
    }
    return MissingInput;
  };

  handleSelectChange = (categoryName, event) => {
    this.setState({ [categoryName]: event.target.value });
  };

  handleReadyToPlay = async () => {
    let allWordsFilled = true;
    this.state.wordsArray.forEach((word) => {
      if (word === '') {
        allWordsFilled = false;
      }
    });

    if (allWordsFilled === true) {
      let joinTeam = this.joinTeam();

      let addWords = this.addWords();

      Promise.all([joinTeam, addWords])
        .then((values) => {
          this.penClick.play();
          this.props.navigate(`/Lobby/${getRoomId()}`, {
            state: {
              chosenTeam: this.state.selectedTeam,
            },
          });
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  };

  handleJoinTeam = async () => {
    this.joinTeam()
      .then((values) => {
        this.penClick.play();
        this.props.navigate(`/Lobby/${getRoomId()}`, {
          state: {
            chosenTeam: this.state.selectedTeam,
          },
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  joinTeam = async () => {
    let sub = this.props.cookies.get('code');

    let bodyForFetchTeams = JSON.stringify({
      chosenTeam: this.state.selectedTeam,
    });

    return checkForCode(
      'PUT',
      `/api/rooms/${getRoomId()}/teams/${sub}/join`,
      this.props,
      bodyForFetchTeams
    );
  };

  addWords = async () => {
    let bodyForFetchWords = JSON.stringify({
      wordsArray: this.state.wordsArray,
    });

    return checkForCode(
      'PUT',
      `/api/rooms/${getRoomId()}/words/addWords`,
      this.props,
      bodyForFetchWords
    );
  };

  render() {
    return (
      <>
        {this.state.roomID !== '' &&
          (this.state.qrCodeOpen ? (
            <div className="Home">
              <h1
                className="joinRoomH1"
                style={{
                  position: 'absolute',
                  top: '0px',
                  fontFamily: 'Poppins',
                }}>
                QR код
              </h1>

              <div className="arrowBackButtonDiv">
                <DesignerButton
                  class="arrowBackButton"
                  onClick={() => {
                    this.penClick.play();
                    this.setState({ qrCodeOpen: false });
                  }}></DesignerButton>
              </div>

              <p className="noGamesFoundExplanationText">
                Lorem Ipsum is simply dummy text of the <br /> printing and
                typesetting industry.
              </p>

              <div className="QROutline">
                <div className="QRwhiteBackground">
                  <QRCode
                    size={256}
                    style={{
                      height: '90%',
                      maxWidth: '90%',
                      width: '90%',
                    }}
                    value={this.state.roomID}
                    viewBox={`0 0 256 256`}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="Home">
              <h1 className="H1TeamAndWords">{this.state.gameName}</h1>
              <p className="roomIDParagraph" style={{ marginBottom: '40px' }}>
                Номер на стаята: {getRoomId()}
              </p>
              <div className="arrowBackButtonOuterDiv">
                <DesignerButton
                  class="arrowBackButton"
                  onClick={this.handleGoBackRoom}></DesignerButton>
              </div>

              <div className="arrowBackButtonDiv_CG QR">
                <DesignerButton
                  class="arrowBackButton qr"
                  onClick={() => {this.props.navigate(`/QRCodePage/${getRoomId()}`);}}></DesignerButton>
              </div>

              <div className="cssBanner">
                <hr className="cssBannerLine" />
                <div className="cssBannerText">Отбор</div>
              </div>
              <select
                value={this.state.selectedTeam}
                onChange={(e) => {
                  this.handleSelectChange('selectedTeam', e);
                }}
                className="selectDropdownMenu"
                id="Teams">
                {this.state.coloredTeams.map((element, index) => (
                  <option key={index} value={element.teamName}>
                    {element.displayName}
                  </option>
                ))}
              </select>

              <div className="cssBanner">
                <hr className="cssBannerLine" />
                <div className="cssBannerText">Категории</div>
              </div>

              {/* here we must add the condition for the dissapearance of the text */}
              {this.props.location.state === null &&
                this.state.wordsArray.map((element, index) => (
                  <div key={index} className="wordsArrayOuterDiv">
                    <DesignerTextField
                      style={{ width: '90%' }}
                      value={element}
                      onChange={(event) => {
                        this.handleWordsArrayInput(event, index);
                      }}
                      onBlur={this.checkIfAllInputsAreFilled}
                      onfocus={this.checkIfAllInputsAreFilled}
                      placeholder={
                        this.state.categories[index]
                          ? 'Напишете ' +
                            this.state.categories[index].categoryName
                          : 'Напишете дума'
                      }></DesignerTextField>
                  </div>
                ))}

              <div className="readyToPlayOuterDiv">
                <div className="readyToPlayInnerDiv">
                  <DesignerButton
                    class="filledButton"
                    disabled={
                      this.props.location.state === null
                        ? this.areAllInputsFilled()
                        : false
                    }
                    onClick={
                      this.props.location.state === null
                        ? this.handleReadyToPlay
                        : this.handleJoinTeam
                    }
                    buttonText="Готово"></DesignerButton>
                </div>
              </div>
            </div>
          ))}
      </>
    );
  }
}

export default withCookies(TeamAndWords);
